import { render, staticRenderFns } from "./notifications-top.pug?vue&type=template&id=3e89d993&lang=pug&external"
import script from "./notifications-top.js?vue&type=script&lang=js&external"
export * from "./notifications-top.js?vue&type=script&lang=js&external"
import style0 from "./notifications-top.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Multiasistencia\\selfcare\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e89d993')) {
      api.createRecord('3e89d993', component.options)
    } else {
      api.reload('3e89d993', component.options)
    }
    module.hot.accept("./notifications-top.pug?vue&type=template&id=3e89d993&lang=pug&external", function () {
      api.rerender('3e89d993', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/notifications-top/index.vue"
export default component.exports